import { createAction, props } from '@ngrx/store';

import { TraceListEntity } from '../components/trace-list/trace-list.entity';

export enum TraceActions {
	FetchTraceListSuccess = '[BE][Trace] fetch trace list success',
	FetchTraceListFail = '[BE][Trace] fetch trace list fail',
	GetTraceListPerPage = '[trace] get trace list per page',
	FetchTraceListPerPageSuccess = '[BE][trace] get trace list per page success',
	FetchTraceListPerPageFail = '[BE][trace] get trace list per page fail',
}

export const getTraceListPerPage = createAction(
	TraceActions.GetTraceListPerPage,
	props<{ offset: number; limit: number }>()
);

export const fetchTraceListPerPageSuccess = createAction(
	TraceActions.FetchTraceListPerPageSuccess,
	props<{ traceList: TraceListEntity; total: number }>()
);

export const fetchTraceListPerPageFail = createAction(
	TraceActions.FetchTraceListPerPageFail,
	props<{ error: unknown }>()
);
